import { VariableKeyBox } from "@/workflow/components/VariableKeyBox";
import { useResolution } from "../context";

export const ResolutionOutputBlock = () => {
  const { attachments } = useResolution();

  return (
    <>
      <VariableKeyBox name={`Veredicto`} type="string" key={`veredicto`} />
      <VariableKeyBox name={`comentario`} type="string" key={`comentario`} />
      {attachments.length === 1 && (
        <VariableKeyBox
          name={`archivo-unico`}
          type="file"
          key={`archivo-unico`}
        />
      )}
      {attachments.length > 1 && (
        <VariableKeyBox
          name={`varios-archivos`}
          type="files"
          key={`varios-archivos`}
        />
      )}
    </>
  );
};
